import PropTypes from "prop-types";
import RichTextDisplay from "components/common/RichTextDisplay";
import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";
import { formatPortalDateTime } from "utils/formatters";

function NewsUpdateCard({ item, index }) {
  const title = String(item.updateTitle ?? item.title ?? "").trim();
  const dateLabel = formatPortalDateTime(
    item.date ?? item.publishedAt ?? item.published_at,
    "",
  );
  const description = String(
    item.updateDescription ?? item.description ?? item.body ?? "",
  ).trim();

  return (
    <article className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm space-y-3">
      <div>
        <h4 className="text-base font-bold text-text-900">
          {title || `Update ${index + 1}`}
        </h4>
        {dateLabel ? (
          <time className="mt-1 block text-xs font-medium text-text-500" dateTime={item.date}>
            {dateLabel}
          </time>
        ) : null}
      </div>

      {description ? (
        <RichTextDisplay html={description} />
      ) : (
        <p className="text-sm text-text-500">No description provided.</p>
      )}
    </article>
  );
}

NewsUpdateCard.propTypes = {
  item: PropTypes.shape({
    updateTitle: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    publishedAt: PropTypes.string,
    published_at: PropTypes.string,
    updateDescription: PropTypes.string,
    description: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default function NewsUpdatesTab() {
  const { project } = useProjectDetailsContext();
  const items = Array.isArray(project?.newsUpdates) ? project.newsUpdates : [];
  const publishedItems = items.filter(
    (item) =>
      String(item.updateTitle ?? item.title ?? "").trim() ||
      String(item.updateDescription ?? item.description ?? item.body ?? "").trim(),
  );

  if (!publishedItems.length) {
    return (
      <p className="mt-3 text-sm text-text-600">
        News and project updates from the issuer will appear in this section.
      </p>
    );
  }

  return (
    <div className="mt-3 space-y-4">
      {publishedItems.map((item, index) => (
        <NewsUpdateCard key={item.id ?? `news-${index}`} item={item} index={index} />
      ))}
    </div>
  );
}

